module.exports = "/static/assets/91e790e3f484472cb898d148c61c3349.png";